import { DiscountType } from "./discount-type-model";
import { Product } from "../products/product.model";
import { Category } from "../category/category.model";


export class Coupon {
  public id: string;
  public couponID: number;
  public plateFormID: number;
  public plateFormName: string;
  public couponCode: string;
  public description: string;
  public discountTypeName: string;
  public discountTypeId: number;
  public startDate: string;
  public endDate: string;
  //public plateForm: number;
  public couponAmount: number;
  public productIds: ProductSelectList[]=[];
  public categoryIds: CategorySelectList[]=[];
  public eligibleCount: number;
  public email: string;
  public couponType: number;
  public maxDiscountAmount: number;
  public minSpending: number;
  public maxSpending: number;
  public limitPerUser: number;
  
  public vendorId: number;
  public isActive: boolean; 
  public discountType: DiscountType;
  public products: Product[]=[];
  public categories: Category[] = [];
  public totalRecords: number;
  public appliedCount: number;
  

}
export class ProductSelectList {
  public productID: number;
  public name: string;
}
export class CategorySelectList {
  public categoryID: number;
  public categoryName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/coupons/coupon-model.ts